import i18n from '@/i18n'
import BlankLayout from '../../layout/blankLayout'
import Layout from '../../companyAdmin/layout.vue'
import List from './list.vue'
import Detail from './detail.vue'
import Premium from './premium.vue'
import Editor from './editor.vue'

const basePath = '/v-admin/client-management/company'

const routes = [
  {
    name: 'companyList',
    path: `${basePath}/list`,
    component: List,
    meta: {
      permission: 'PERM_COMPANY_APPROVAL',
      get title () {
        return i18n.t('admin.company.companyApprovalManagement.title.companyListTitle')
      },
      menu: {
        get label () {
          return i18n.t('admin.company.companyApprovalManagement.menu.companyListMenu')
        }
      }
    }
  },
  {
    name: 'companyDetailPage',
    component: BlankLayout,
    path: `${basePath}/:companyId`,
    redirect: `${basePath}/:companyId`,
    meta: {
      permission: 'PERM_COMPANY_APPROVAL',
      get title () {
        return i18n.t('admin.company.companyApprovalManagement.title.companyDetailTitle')
      },
      menu: {
        get label () {
          return i18n.t('admin.company.companyApprovalManagement.menu.companyDetailMenu')
        }
      }
    },
    children: [
      {
        name: 'companyDetail',
        component: Detail,
        path: `${basePath}/:companyId`,
        meta: {
          breadcrumb: { hidden: true },
          permission: 'PERM_COMPANY_APPROVAL',
          get title () {
            return i18n.t('admin.company.companyApprovalManagement.title.companyDetailTitle')
          },
          menu: {
            get label () {
              return i18n.t('admin.company.companyApprovalManagement.menu.companyDetailMenu')
            }
          }
        }
      },
      {
        name: 'companyEdit',
        component: Editor,
        path: `${basePath}/:companyId/edit`,
        meta: {
          permission: 'PERM_COMPANY_APPROVAL',
          get title () {
            return i18n.t('admin.company.companyApprovalManagement.title.editCompanyTitle')
          },
          menu: {
            get label () {
              return i18n.t('admin.company.companyApprovalManagement.menu.editCompanyMenu')
            }
          }
        }
      },
      {
        name: '',
        path: `${basePath}/:companyId/premium`,
        component: Premium,
        meta: {
          permission: 'PERM_COMPANY_APPROVAL',
          get title () {
            return i18n.t('admin.company.companyApprovalManagement.title.premiumManagementTitle')
          },
          menu: {
            get label () {
              return i18n.t('admin.company.companyApprovalManagement.menu.premiumManagementMenu')
            }
          }
        }
      }
    ]
  }
]

export default {
  name: 'customerManagement',
  path: `${basePath}`,
  component: Layout,
  redirect: `${basePath}/list`,
  meta: {
    permission: 'PERM_COMPANY_APPROVAL',
    get title () {
      return i18n.t('admin.customer.customerManagement.title')
    },
    isNewPage: true,
    isAllInclude: true,
    // breadcrumb: { hidden: true },
    menu: {
      get label () {
        return i18n.t('admin.customer.customerManagement.menu')
      }
    }
  },
  children: routes
}
